import { common, IOHelper, JSONHelper, utils, } from '@neo-one/client-common';
import { ContractParameterBase } from './ContractParameterBase';
import { ContractParameterType } from './ContractParameterType';
export class Hash160ContractParameter extends ContractParameterBase {
    constructor(value) {
        super();
        this.type = ContractParameterType.Hash160;
        this.value = value;
        this.sizeInternal = utils.lazy(() => IOHelper.sizeOfUInt160);
    }
    static deserializeWireBase(options) {
        const { reader } = options;
        super.deserializeContractParameterBaseWireBase(options);
        const value = reader.readUInt160();
        return new this(value);
    }
    get size() {
        return this.sizeInternal();
    }
    asBuffer() {
        return common.uInt160ToBuffer(this.value);
    }
    serializeWireBase(writer) {
        super.serializeWireBase(writer);
        writer.writeUInt160(this.value);
    }
    serializeJSON(_context) {
        return {
            type: 'Hash160',
            value: JSONHelper.writeUInt160(this.value),
        };
    }
}

//# sourceMappingURL=Hash160ContractParameter.js.map
